// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/account/v1/legacy_portal_service.proto (package spwn.account.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { LegacyPortalAccountServiceExchangeStartggCodeRequest, LegacyPortalAccountServiceExchangeStartggCodeResponse, LegacyPortalAccountServiceGetStartggEntryStatusRequest, LegacyPortalAccountServiceGetStartggEntryStatusResponse, LegacyPortalAccountServiceIssueOidcLoginCodeRequest, LegacyPortalAccountServiceIssueOidcLoginCodeResponse, LegacyPortalAccountServiceLinkWithFanyIdRequest, LegacyPortalAccountServiceLinkWithFanyIdResponse, LegacyPortalAccountServiceSignInWithFanyIdRequest, LegacyPortalAccountServiceSignInWithFanyIdResponse, LegacyPortalAccountServiceStartStartggLinkRequest, LegacyPortalAccountServiceStartStartggLinkResponse } from "./legacy_portal_service_pb";
import { MethodKind } from "@bufbuild/protobuf";
/**
 * @generated from service spwn.account.v1.LegacyPortalAccountService
 */
export const LegacyPortalAccountService = {
    typeName: "spwn.account.v1.LegacyPortalAccountService",
    methods: {
        /**
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.SignInWithFanyId
         */
        signInWithFanyId: {
            name: "SignInWithFanyId",
            I: LegacyPortalAccountServiceSignInWithFanyIdRequest,
            O: LegacyPortalAccountServiceSignInWithFanyIdResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.LinkWithFanyId
         */
        linkWithFanyId: {
            name: "LinkWithFanyId",
            I: LegacyPortalAccountServiceLinkWithFanyIdRequest,
            O: LegacyPortalAccountServiceLinkWithFanyIdResponse,
            kind: MethodKind.Unary,
        },
        /**
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.IssueOidcLoginCode
         */
        issueOidcLoginCode: {
            name: "IssueOidcLoginCode",
            I: LegacyPortalAccountServiceIssueOidcLoginCodeRequest,
            O: LegacyPortalAccountServiceIssueOidcLoginCodeResponse,
            kind: MethodKind.Unary,
        },
        /**
         * start.gg 連携の開始。CSRF 用の state を発行して HttpOnly cookie にセットし、
         * 認可画面の URL を返す。cookie は ExchangeStartggCode でサーバ側照合する。
         *
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.StartStartggLink
         */
        startStartggLink: {
            name: "StartStartggLink",
            I: LegacyPortalAccountServiceStartStartggLinkRequest,
            O: LegacyPortalAccountServiceStartStartggLinkResponse,
            kind: MethodKind.Unary,
        },
        /**
         * start.gg OAuth: portal で受け取った authorization code を access token に交換し、
         * 連携した start.gg ユーザーの id / gamerTag を返す。state cookie と照合してから交換する。
         * トークンはサーバに保持しない（連携状態の永続化は呼び出し側の責務）。
         *
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.ExchangeStartggCode
         */
        exchangeStartggCode: {
            name: "ExchangeStartggCode",
            I: LegacyPortalAccountServiceExchangeStartggCodeRequest,
            O: LegacyPortalAccountServiceExchangeStartggCodeResponse,
            kind: MethodKind.Unary,
        },
        /**
         * start.gg: 指定した start.gg ユーザーが対象イベントに entry 済みかを返す。
         * 登録直後の反映を優先するため NO_SIDE_EFFECTS は付けない（GET キャッシュを避け POST で毎回フレッシュ）。
         *
         * @generated from rpc spwn.account.v1.LegacyPortalAccountService.GetStartggEntryStatus
         */
        getStartggEntryStatus: {
            name: "GetStartggEntryStatus",
            I: LegacyPortalAccountServiceGetStartggEntryStatusRequest,
            O: LegacyPortalAccountServiceGetStartggEntryStatusResponse,
            kind: MethodKind.Unary,
        },
    }
};
//# sourceMappingURL=legacy_portal_service_connect.js.map